var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-badge',{staticClass:"mark",attrs:{"value":_vm.notification,"is-dot":_vm.alert,"hidden":_vm.shouldHide}},[(_vm.showIcon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.label)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5615fbc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderMenuItem.vue
// module id = vMLJ
// module chunks = 1